import React from "react";

const RiskRatingContext = React.createContext<any>(null);
RiskRatingContext.displayName = "RiskRatingContext";

export default RiskRatingContext;
